/* eslint-disable react/prop-types */
import { networkLogo } from "@/constants";
import { cn } from "@/lib/utils";
import React from "react";

const NetworkTiles = ({
  setValue,
  valueKey,
  selected = "",
  telcos,
  type = "airtime",
}) => {
  return (
    <div className="mt-3">
      <div className="grid grid-cols-4 justify-between">
        {networkLogo.map((network, index) => (
          <div
            key={index}
            onClick={() => {
              if (setValue) {
                if (type == "airtime") {
                  const index = telcos.findIndex((telco) =>
                    telco?.toLowerCase()?.includes(network.name.toLowerCase()),
                  );
                  setValue(valueKey, index);
                } else {
                  const index = telcos.find((telco) =>
                    telco?.toLowerCase()?.includes(network.name.toLowerCase()),
                  );
                  setValue(valueKey, index);
                  setValue("plan", null);
                }
              }
            }}
          >
            <div
              className={cn(`mb-2 w-fit rounded-lg p-2`, {
                "border-primary border-2":
                  selected &&
                  typeof selected === "string" &&
                  selected.toLowerCase().includes(network.name.toLowerCase()),
              })}
            >
              <img
                src={network.img}
                alt="network-logo"
                className={cn(`size-16 cursor-pointer rounded-lg`)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NetworkTiles;
